import Vue from 'vue';
import client from '@/apis/client';

const localize = (item, key) => {
  const locale = Vue.$cookies.get('locale') || 'th_TH';

  if (locale === 'en_US' && item[`${key}_en`]) {
    return item[`${key}_en`];
  }

  return item[key];
};

export const createProduct = async (body) => {
  const { data } = await client.post('/products', body);

  return data;
};

export const viewProduct = async (id) => {
  const { data } = await client.put(`/products/${id}/view`);

  return data;
};

export const updateProduct = async (id, body) => {
  const { data } = await client.put(`/products/${id}`, body);

  return data;
};

export const removeProduct = async (id) => {
  const { data } = await client.delete(`/products/${id}`);

  return data;
};

export const getProducts = async (page, size) => {
  const params = {};

  if (page) {
    params.current_page = page;
  }
  if (size) {
    params.page_size = size;
  }

  const { data: { data: items, total } } = await client.get('/products', { params });

  const offset = (page - 1) * size;
  const products = items.map((item, index) => ({
    ...item,
    no: offset + (index + 1),
    product_name_localized: localize(item, 'product_name'),
    product_information_localized: localize(item, 'product_information'),
    product_description_localized: localize(item, 'product_description'),
  }));

  return { products, total };
};

export const getRelatedProducts = async (categories = null, exclude = '') => {
  const params = {
    current_page: 1,
    page_size: 8,
    categories: categories && categories.length > 0 ? `[${categories.join(',')}]` : undefined,
    exclude: exclude || undefined,
  };

  const { data: { data: items } } = await client.get('/products', { params });

  const products = items.map((item) => ({
    ...item,
    product_name_localized: localize(item, 'product_name'),
    product_information_localized: localize(item, 'product_information'),
    product_description_localized: localize(item, 'product_description'),
  }));

  return products;
};
export const getProductsByCategories = async (page, size, categories = null) => {
  const params = {};

  if (page) {
    params.current_page = page;
  }
  if (size) {
    params.page_size = size;
  }
  if (categories != null) {
    params.categories = categories;
  }

  const { data: { data: items, total } } = await client.get('/products/getDataByCat/', { params });

  const offset = (page - 1) * size;
  const products = items.map((item, index) => ({
    ...item,
    no: offset + (index + 1),
    product_name_localized: localize(item, 'product_name'),
    product_information_localized: localize(item, 'product_information'),
    product_description_localized: localize(item, 'product_description'),
  }));

  return { products, total };
};
export const getFeaturedProducts = async () => {
  const params = {
    current_page: 1,
    page_size: 4,
    featured: true,
  };

  const { data: { data: items } } = await client.get('/products', { params });

  const products = items.map((item) => ({
    ...item,
    product_name_localized: localize(item, 'product_name'),
    product_information_localized: localize(item, 'product_information'),
    product_description_localized: localize(item, 'product_description'),
  }));

  return products;
};

export const getProduct = async (id) => {
  let { data: { data } } = await client.get(`/products/${id}`);

  if (typeof data === 'object') {
    data = {
      ...data,
      product_name_localized: localize(data, 'product_name'),
      product_information_localized: localize(data, 'product_information'),
      product_description_localized: localize(data, 'product_description'),
    };
  }

  return data;
};
